<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  value: string | null
  random?: boolean
  selected?: boolean
  size?: 'lg' | 'md'
}>()

const rank = computed(() =>
  props.value ? (props.value[0].toUpperCase() === 'T' ? '10' : props.value[0]) : null
)
const suit = computed(() => (props.value ? props.value[1].toLowerCase() : null))
</script>
<template>
  <div
    class="simple-card"
    :class="{
      'simple-card--opened': !!rank,
      'simple-card--closed': !rank && !random,
      'simple-card--random': !rank && random,
      'simple-card--selected': selected,
      [`simple-card--${size}`]: true,
      [`simple-card--${suit}`]: true
    }"
  >
    <div v-if="rank" class="simple-card__front">
      <svg class="simple-card__rank mb-px h-[21px] w-full"><use :href="`#rank-${rank}`" /></svg>
      <svg class="simple-card__suit h-[15px] w-full"><use :href="`#suit-${suit}`" /></svg>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.simple-card {
  // md
  --card-width: 28px;
  --card-height: 43px;
  --card-radius: 3px;
  --card-border-width: 1px;
  --card-highlight-width: 1.5px;
  --card-highlight-blur: 1px;
  --card-pt: 2px;
  --card-rank-h: 21px;
  --card-suit-h: 15px;

  width: var(--card-width);
  height: var(--card-height);
  border-radius: var(--card-radius);
  flex-shrink: 0;
  flex-grow: 0;

  &--c,
  &--s {
    color: #21252d;
  }

  &--h,
  &--d {
    color: #cc3933;
  }

  &--opened {
    padding: var(--card-border-width);
    background: linear-gradient(to bottom, #d6e1e1 0%, #d6e1e1 50%, #fff 100%);
  }

  &--closed {
    background: url('@/assets/cards/back-simple.svg');
    background-size: cover;
  }
  &--random {
    background: url('@/assets/cards/back-simple-random-2.svg');
    background-size: cover;
  }

  &--selected {
    box-shadow: 0 0 var(--card-highlight-blur) var(--card-highlight-width) #4b32e4;
  }

  &__front {
    width: 100%;
    height: 100%;
    padding-top: var(--card-pt);
    background: #fff;
    text-align: center;
    border-radius: var(--card-radius);
  }
  &__rank {
    height: var(--card-rank-h);
    width: 100%;
    margin-bottom: 2px;
  }
  &__suit {
    height: var(--card-suit-h);
    width: 100%;
  }

  // sizes
  &--lg {
    --card-width: 46px;
    --card-height: 70px;
    --card-radius: 6px;
    --card-border-width: 2px;
    --card-highlight-width: 2.5px;
    --card-highlight-blur: 1px;
    --card-pt: 4px;
    --card-rank-h: 35px;
    --card-suit-h: 25px;
  }
}
</style>
